import React from "react";
import { Table } from "../../../ui/Table";
import PropTypes from "prop-types";
import { FormatCurrency3Dec, FormatInt } from "../../../../utils/FormatData";
import { dateFormat } from "../../../../utils/dateHelpers";
import Icon from "../../../Icon";

const TablePartners = ({ data, loading, source = "default" }) => {
  const COLUMNS = [
    {
      Header: "Fecha de creación",
      accessor: "dt_create",
      Cell: (rowData) => {
        let value = rowData.row.original.dt_create;
        return dateFormat(value, "DD/MM/YYYY");
      },
      Footer: () => {
        return <div className="font-bold">Total</div>;
      },
    },
    {
      Header: "Campaña",
      accessor: "vc_externalname",
      Cell: (rowData) => {
        let value = rowData.row.original.vc_externalname;
        return (
          <div className="truncate w-[700px] overflow-hidden text-md font-semibold">
            <span>{value}</span>
          </div>
        );
      },
    },
    {
      Header: "ID Campaña",
      accessor: "i_campaignid",
    },
    {
      Header: "Carrier",
      accessor: "vc_carrier",
    },
    {
      Header: "Programados",
      accesor: "i_programed",
      Cell: (rowData) => {
        let value = rowData.row.original.i_programed;
        return FormatInt(value);
      },
      Footer: (columnData) => {
        return (
          <div className="font-bold">
            {FormatInt(
              columnData.data.reduce(
                (i_programed, item) =>
                  Number(i_programed) + Number(item.i_programed),
                0,
              ),
            )}
          </div>
        );
      },
    },
    {
      Header: "Entregados",
      accessor: "i_delivered",
      Cell: (rowData) => {
        let value = rowData.row.original.i_delivered;
        return FormatInt(value);
      },
      Footer: (columnData) => {
        return (
          <div className="font-bold">
            {FormatInt(
              columnData.data.reduce(
                (i_delivered, item) =>
                  Number(i_delivered) + Number(item.i_delivered),
                0,
              ),
            )}
          </div>
        );
      },
    },
    {
      Header: "Errores",
      accessor: "i_errors",
      Cell: (rowData) => {
        let value = rowData.row.original.i_errors;
        return FormatInt(value);
      },
      Footer: (columnData) => {
        return (
          <div className="font-bold">
            {FormatInt(
              columnData.data.reduce(
                (i_errors, item) => Number(i_errors) + Number(item.i_errors),
                0,
              ),
            )}
          </div>
        );
      },
    },
    {
      Header: "Total",
      accessor: "i_total",
      Cell: (rowData) => {
        let value = rowData.row.original.i_total;
        return FormatInt(value);
      },
      Footer: (columnData) => {
        return (
          <div className="font-bold text-center">
            {FormatInt(
              columnData.data.reduce(
                (i_total, item) => Number(i_total) + Number(item.i_total),
                0,
              ),
            )}
          </div>
        );
      },
    },
    {
      Header: "Monto",
      accessor: "n_amount",
      Cell: (rowData) => {
        let value = Number(rowData.row.original.n_amount);
        return FormatCurrency3Dec(value);
      },
      Footer: (columnData) => {
        return (
          <div className="font-bold text-center">
            {FormatCurrency3Dec(
              columnData.data.reduce(
                (n_amount, item) => Number(n_amount) + Number(item.n_amount),
                0,
              ),
            )}
          </div>
        );
      },
    },
  ];

  const CONCILIATION_COLUMNS = [
    {
      Header: "Fecha de creación",
      accessor: "dt_create",
      Cell: (rowData) => {
        let value = rowData.row.original.dt_create;
        return dateFormat(value, "DD/MM/YYYY");
      },
      Footer: () => {
        return <div className="font-bold">Total</div>;
      },
    },
    {
      Header: "Campaña",
      accessor: "vc_externalname",
      Cell: (rowData) => {
        let value = rowData.row.original.vc_externalname;
        return (
          <div className="truncate w-[700px] overflow-hidden text-md font-semibold">
            <span>{value}</span>
          </div>
        );
      },
    },
    {
      Header: "ID Campaña",
      accessor: "i_campaignid",
    },
    {
      Header: "Entregados",
      accessor: "i_delivered",
      Cell: (rowData) => {
        let value = rowData.row.original.i_delivered;
        return FormatInt(value);
      },
      Footer: (columnData) => {
        return (
          <div className="font-bold">
            {FormatInt(
              columnData.data.reduce(
                (i_delivered, item) =>
                  Number(i_delivered) + Number(item.i_delivered),
                0,
              ),
            )}
          </div>
        );
      },
    },
    {
      Header: "Errores",
      accessor: "i_errors",
      Cell: (rowData) => {
        let value = rowData.row.original.i_errors;
        return FormatInt(value);
      },
      Footer: (columnData) => {
        return (
          <div className="font-bold">
            {FormatInt(
              columnData.data.reduce(
                (i_errors, item) => Number(i_errors) + Number(item.i_errors),
                0,
              ),
            )}
          </div>
        );
      },
    },
    {
      Header: "Total",
      accessor: "i_total",
      Cell: (rowData) => {
        let value = rowData.row.original.i_total;
        return FormatInt(value);
      },
      Footer: (columnData) => {
        return (
          <div className="font-bold">
            {FormatInt(
              columnData.data.reduce(
                (i_total, item) => Number(i_total) + Number(item.i_total),
                0,
              ),
            )}
          </div>
        );
      },
    },
    {
      Header: "Enviados Clevertap",
      accessor: "i_sent",
      Cell: (rowData) => {
        let value = Number(rowData.row.original.i_sent);
        return FormatInt(value);
      },
      Footer: (columnData) => {
        return (
          <div className="font-bold">
            {FormatInt(
              columnData.data.reduce(
                (i_sent, item) => Number(i_sent) + Number(item.i_sent),
                0,
              ),
            )}
          </div>
        );
      },
    },
    {
      Header: "Diferencia",
      accessor: "i_dif",
      Cell: (rowData) => {
        const raw = Number(rowData.row.original.i_dif);
        const abs = Math.abs(raw);
        const formatted = FormatInt(abs);

        return (
          <span className="font-bold flex items-center gap-2">
            {abs > 0 && <Icon icon="warning" className="text-orange-400" />}
            {formatted}
          </span>
        );
      },

      Footer: (columnData) => {
        return (
          <div className="font-bold">
            {FormatInt(
              columnData.data.reduce(
                (i_dif, item) =>
                  Number(Math.abs(i_dif)) + Number(Math.abs(item.i_dif)),
                0,
              ),
            )}
          </div>
        );
      },
    },
  ];

  const mapColumns = {
    default: COLUMNS,
    conciliation: CONCILIATION_COLUMNS,
  };

  return (
    <Table
      data={data}
      columns={mapColumns[source]}
      loading={loading}
      config={{
        search: true,
        footer: true,
        printfooter: true,
        pageSize: 10,
        perPage: 10,
        export: true,
      }}
      rowRule={(row) => {
        const raw = Number(row.original.i_dif);
        const abs = Math.abs(raw);
        if (abs > 0) {
          return "bg-yellow-50";
        }
      }}
    />
  );
};
TablePartners.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
  source: PropTypes.string,
};
export default TablePartners;
